import { IProduct, IProductStatus, ICenterProducts, ICrmAccountPlan, ICrmProductPlan, IContact } from "@nkr/models/index";

export interface ICrmState {
    productList: IProduct[],
    staffList: IContact[],
    accountPlan: ICrmAccountPlan
}
